import { formatLocaleDateString } from "../utils";

interface LocaleDateProps {
	date: Date;
	isEmptyIfInvalid?: boolean;
}

export const LocaleDateRed = ({
	date,
	isEmptyIfInvalid = true,
}: LocaleDateProps) => {
	const dateString = formatLocaleDateString(date, isEmptyIfInvalid);
	if (new Date(date) <= new Date()) {
		return <span className="text-danger">{dateString}</span>;
	} else {
		return <>{dateString}</>;
	}
};
